/**
 *
 * FBMobileWrapper
 *
 */

import React from 'react';
import classNames from 'classnames';

// styles
import './style.scss';

// layout components
import ErrorBoundary from 'engine/ErrorBoundary';
import Preloader from 'components/Preloader';
// inner communication components 
import {
  FBMobileSectionHeader,
  FBAdminAnswerCard,
} from 'mobile/components/Communications';


function FBMobileWrapper({
  key,
  showHeader,
  showAdminAnswer,
  adminAnswer,
  types,
  loading,
  // default props
  children,
  className,
  ...rest
}) {
  const childClassNames = classNames('tcf-fb-wrapper-group-preview', 'tcf-fb-group-preview', className);

  return (
    <div {...rest} key={key} className={classNames(
      'tcf-fb-wrapper-group-preview',
      'tcf-fb-group-preview',
      className
    )}>
      <FBMobileSectionHeader key={`${key}-header`} visibility={showHeader} types={types} />
      {(!!showAdminAnswer && !!adminAnswer) && (
        <ErrorBoundary>
          <FBAdminAnswerCard adminAnswer={adminAnswer} />
        </ErrorBoundary>
      )}
      <div className='tcf-fb-group-preview__content'>
        {loading && <Preloader />}
        {children}
      </div>
    </div>
  );
}

FBMobileWrapper.defaultProps = {
  types: ['forms'],
  showHeader: true,
  showAdminAnswer: true,
  adminAnswer: false,
};

export default FBMobileWrapper;
